var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectrolytes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.444 30.5927L133.622 39.0803L141.444 45.8307V61.1905L136.862 68.8095L141.444 75.6513V183.572L131.544 191.191L141.444 198.81V214.169L133.794 221.788L141.444 229.407V260H3.82471V229.407L10.5497 221.788L3.82471 214.169V198.81L11.8449 191.191L3.82471 183.572V75.7834L9.12243 68.8095L3.82471 61.1905V45.8307L11.5859 38.2117L3.82471 30.5927V0H141.444V30.5927Z",
    fill: "#00429C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.444 30.5927L133.622 39.0803L141.444 45.8307V61.1905L136.862 68.8095L141.444 75.6513V183.572L131.544 191.191L141.444 198.81V214.169L133.794 221.788L141.444 229.407V260H72.6343V0H141.444V30.5927Z",
    fill: "#00347B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7163 30.5928H95.5521V76.4285H49.7163V30.5928Z",
    fill: "#F6E178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6343 30.5928H95.5521V76.4285H72.6343V30.5928Z",
    fill: "#EEC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4175 91.7832H110.846V152.918H34.4175V91.7832Z",
    fill: "#7DD5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6343 91.7832H110.846V152.918H72.6343V91.7832Z",
    fill: "#6BA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5521 206.489C95.5521 219.127 85.2715 229.407 72.6342 229.407C59.9968 229.407 49.7163 219.127 49.7163 206.489C49.7163 194.525 65.4881 177.315 72.6342 169.228C80.018 177.584 95.5521 194.579 95.5521 206.489Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5521 206.489C95.5521 219.127 85.2716 229.407 72.6343 229.407V169.228C80.0181 177.584 95.5521 194.579 95.5521 206.489Z",
    fill: "#CC295F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82471 30.5928H34.3869V45.8307H3.82471V30.5928Z",
    fill: "#CEE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82471 61.1904H34.3869V76.4284H3.82471V61.1904Z",
    fill: "#CEE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.876 30.5928H141.444V45.8307H110.876V30.5928Z",
    fill: "#A1D7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.876 61.1904H141.444V76.4284H110.876V61.1904Z",
    fill: "#A1D7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82471 183.571H34.3869V198.809H3.82471V183.571Z",
    fill: "#CEE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82471 214.169H34.3869V229.407H3.82471V214.169Z",
    fill: "#CEE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.876 183.571H141.444V198.809H110.876V183.571Z",
    fill: "#A1D7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.876 214.169H141.444V229.407H110.876V214.169Z",
    fill: "#A1D7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.876 30.5928C240.876 202.08 241.744 159.366 238.276 225.567C238.276 244.528 225.45 252.757 206.489 252.757C187.523 252.757 177.583 243.619 177.583 224.658L172.097 175.922V30.5928H240.876Z",
    fill: "#E5F2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.876 30.5928C240.876 202.08 241.744 159.366 238.276 225.567C238.276 244.528 225.45 252.757 206.489 252.757V30.5928H240.876Z",
    fill: "#CEE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.876 175.922V225.613C240.876 244.574 225.45 260 206.489 260C187.523 260 172.097 244.574 172.097 225.613V175.922H240.876Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.876 175.922V225.613C240.876 244.574 225.45 260 206.489 260V175.922H240.876Z",
    fill: "#CC295F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.798 0H256.175V45.8307H156.798V0Z",
    fill: "#CEE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.489 0H256.175V45.8307H206.489V0Z",
    fill: "#A1D7F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrolytes);
export default __webpack_public_path__ + "static/media/Electrolytes.30c706acc0a79754215fd272eb836bd5.svg";
export { ForwardRef as ReactComponent };